/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForAzureApplication extends models.ServiceAccountCredentialsBaseForAzure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForAzureApplication");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForAzureApplication.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForAzureApplication>): ServiceAccountCredentialsBaseForAzureApplication {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForAzureApplication(), model);
        ServiceAccountCredentialsBaseForAzureApplication.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForAzureApplication>): ServiceAccountCredentialsBaseForAzureApplication {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForAzureApplication.newInstance(<ServiceAccountCredentialsBaseForAzureApplication> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForAzureApplication) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForAzureApplication.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForAzureApplication): boolean {
        if (models.ServiceAccountCredentialsBaseForAzure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForAzureApplication.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id. This is a required field.
     */
    tenant_id: string;

    /**
     * Application Id. This is a required field.
     */
    application_id: string;

    /**
     * Application Secret. This is a required field.
     */
    application_secret: string;

}
